import Vue from 'vue'
import VueRouter from 'vue-router'

import Users from '../components/Users.vue'

import First from '../components/First.vue'
import Motors from '../components/Motors.vue'
import MotorTypes from '../components/MotorTypes.vue'
import MotorTypesAdd from '../components/MotorTypesAdd.vue'
import MotorTypeAddFromExcell from '../components/MotorTypeAddFromExcell.vue'
import MotorOlustur from '../components/MotorOlustur.vue'
import MotorPerformance from '../components/MotorPerformances.vue'
import MotorPerformanceAdd from '../components/MotorPerformanceAdd.vue'

// import Login from '../../../pumpselection_public/src/components/Login.vue'
import Login from '../components/Login.vue'

import Pumps from '../components/Pumps.vue'
import PumpTypes from '../components/PumpTypes.vue'
import PumpTypeAddFromExcell from '../components/PumpTypeAddFromExcell.vue'
import PumpTypesAdd from '../components/PumpTypesAdd.vue'
import PumpTypeInformation from '../components/PumpTypeInformation.vue'

import PumpPerformance from '../components/PumpPerformances.vue'
import PompaOlustur from '../components/PompaOlustur.vue'
import PompaPerformansKaydet from '../components/PompaPerformansKaydet.vue'

import Settings from '../components/Settings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/users',
    name: 'users',
    component: Users
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/',
    name: 'login',
    component: Login
  },{
    path: '/pumps',
    name: 'pumps',
    component: Pumps
  },
  {
    path: '/pump-performance-datas',
    name: 'pump-performance-datas',
    component: PumpPerformance
  },
  {
    path: '/motor-performance-datas',
    name: 'motor-performance-datas',
    component: MotorPerformance
  },
  {
    path: '/motor-type-add-from-excell',
    name: 'motor-type-add-from-excell',
    component: MotorTypeAddFromExcell
  },
  {
    path: '/pump-type-add-from-excell',
    name: 'pump-type-add-from-excell',
    component: PumpTypeAddFromExcell
  },
  {
    path: '/pump-type-info',
    name: 'pump-type-info',
    component: PumpTypeInformation
  }
  
  ,
  {
    path: '/pump-performance-add',
    name: 'pump-performance-add',
    component: PompaPerformansKaydet
  },
  {
    path: '/motor-performance-add',
    name: 'motor-performance-add',
    component: MotorPerformanceAdd
  }
  
  ,
  {
    path: '/motor-types',
    name: 'motor-types',
    component: MotorTypes
  },  {
    path: '/motor-types-add',
    name: 'motor-types-add',
    component: MotorTypesAdd
  },
  {
    path: '/pump-types',
    name: 'pump-types',
    component: PumpTypes
  },
  {
    path: '/pump-types-add',
    name: 'pump-types-add',
    component: PumpTypesAdd
  },
  {
    path: '/pump-types-edit/:editPumpTypeId',
    name: 'pump-types-edit',
    component: PumpTypesAdd,
    props: true
  },
  {
    path: '/motor-types-edit/:editMotorTypeId',
    name: 'motor-types-edit',
    component: MotorTypesAdd,
    props: true
  },
  {
    path: '/pump',
    name: 'pump',
    component: Pumps
  },
  {
    path: '/pump-add',
    name: 'pump-add',
    component: PompaOlustur
  }
  ,
  {
    path: '/pump-edit/:editPumpId',
    name: 'pump-edit',
    component: PompaOlustur,
    props: true
  },
  {
    path: '/motor-add',
    name: 'motor-add',
    component: MotorOlustur
  },{
    path: '/first',
    name: 'first',
    component: First
  },
  {
    path: '/motor-edit/:editMotorId',
    name: 'motor-edit',
    component: MotorOlustur,
    props: true
  },

  {
    path: '/motor',
    name: 'motor',
    component: Motors
  },

  {
    path: '/motorrrrr',
    name: 'Motorrrrrr',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "motor" */ '../components/MotorOlustur.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router